import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./CoinLessonPopup.css";
import coins from '../imagesHome/coins.png';

const apiUrl = process.env.REACT_APP_API_URL;

const CoinLessonPopup = ({ coinsCount }) => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const btnRef = useRef(null);
  const popupRef = useRef(null);
  const [coinsValue, setCoinsValue] = useState(0);

  // Fetch Coins din API
  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    const fetchCoins = async () => {
      try {
        const userRes = await fetch(`${apiUrl}/user`, {
          credentials: 'include',
        });
        const user = await userRes.json();
        
        const statsRes = await fetch(
          `${apiUrl}/user/${user.user_id}/stats`,
          { credentials: 'include' }
        );
        const stats = await statsRes.json();
        setCoinsValue(stats.coins ?? 0);
      } catch (error) {
        console.error('Error fetching coins:', error);
      }
    };
    fetchCoins();
  }, []);

  // Închide popup dacă dai click pe afară
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target) &&
        btnRef.current &&
        !btnRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="dimension-icons">
      <div ref={btnRef} className="metric-pill" onClick={() => setOpen(!open)}>
        <div className="metric-value color-size-numbers-coin">{coinsValue}</div>
        <img src={coins} className="lesson-icon-numbers" />
      </div>

      {open && createPortal(
        <>
          <div className="coin-lesson-overlay" onClick={() => setOpen(false)} />
          <div
            className={`coin-lesson-popup ${isMobile ? "mobile" : "desktop"}`}
            ref={popupRef}
          >
            <button
              className="coin-lesson-close"
              onClick={() => setOpen(false)}
            >
              ×
            </button>
            <div className="coin-lesson-content">
              <div className="coin-lesson-number">{coinsValue}</div>
              <img src={coins} className="lesson-icon-numbers" />
              <h3>Ai {coinsValue} monede</h3>
              <p>Folosește monedele pentru a cumpăra lecții sau avantaje</p>
              <button className="coin-lesson-btn">Continuă învățarea</button>
            </div>
          </div>
        </>,
        document.body
      )}
    </div>
  );
};

export default CoinLessonPopup;
